<script lang="ts">
    import type { FormSubmitEvent } from "../types/form";
    import type {Contact, ContactNote} from "../../models/contact";
    import {get, post, put} from "../services/http.service";

    export let id: string;

    async function getContact(id: string) {
      const contact = await get(`/api/contacts/${id}`);
      return contact;
    }

    async function getContactNotes(id: string): Promise<ContactNote[]> {
      const notes = await get(`/api/contacts/${id}/notes`);
      return notes;
    }

    let contact: Contact;
    let notes: ContactNote[] = [];

    id && getContact(id).then(x => contact = x);
    id && getContactNotes(id).then(x => notes = x);

    async function handleSubmit(ev: FormSubmitEvent) {
      const form = ev.target as HTMLFormElement;
      const formData = new FormData(form);
      const rawResponse = await put(`/api/contacts/${id}`, {
        name: formData.get('name'),
        email: formData.get('email'),
        company: formData.get('company'),
        phone: formData.get('phone')
      });
    }

    async function handleSubmitNote(event: FormSubmitEvent) {
        const form = event.target as HTMLFormElement;
        const formData = new FormData(form);
        const body = {
          note: formData.get('note')
        } as ContactNote;
        await post(`/api/contacts/${id}/notes`, body);

        notes = [...notes, body];
        form.reset();
    }
</script>

<svelte:head>
    <title>All about {contact?.name}</title>
</svelte:head>

{#if contact}
    <form on:submit|preventDefault={handleSubmit}>
        <fieldset>
            <legend>Update</legend>

            <p>
                <input bind:value={contact.name}
                       type="text"
                       name="name"
                       required
                       readonly
                       minlength="2"
                       placeholder="Name"/>
            </p>
            <p>
                <input bind:value={contact.email}
                       type="email"
                       name="email"
                       required
                       readonly
                       minlength="2"
                       placeholder="Email"/>
            </p>
            <p>
                <input bind:value={contact.company}
                       type="text"
                       readonly
                       name="company"
                       placeholder="Company"/>
            </p>
            <p>
                <input bind:value={contact.phone}
                       type="text"
                       readonly
                       name="phone"
                       placeholder="Phone"/>
            </p>
            <p>
                <button type="submit">Save</button>
            </p>
        </fieldset>
    </form>
{/if}

<ul>
    {#each notes as {note}}
    <li>{note}</li>
    {/each}
</ul>

<form on:submit|preventDefault={handleSubmitNote}>
    <fieldset>
        <legend>Note</legend>

        <p>
            <input type="text" name="note" required maxlength="1024" placeholder="Note"/>
        </p>
        <p>
            <button type="submit">+ Add note</button>
        </p>
    </fieldset>
</form>
